// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured_fact_check_container {
  width: 90%;
  display: flex;
  z-index: 2;
  position: relative;
  gap: 3%;
}

.featured_fact_check_image_component {
  
  height: 100%;
  cursor: pointer;
}
.featured_fact_check_image {
  width: 100% !important;
  object-fit: cover;
  border-radius: 10px;
}
.featured_fact_check_thumbnail_overlay_content {
  position: absolute !important;
  bottom: 20px;
  background-color: rgba(20, 15, 45, 0.9) !important;
  color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 2%;
}
.featured_fact_check_image_component_title {
  color: #ffffff;
  font-weight: 550;
}
.featured_fact_check_content {
  width: 40%;
  display: flex;
  flex-direction: column;
}
.featured_fact_check_continue_reading_wrapper {
  display: flex;
  align-items: center;
}
.featured_story_fact_check {
  color: var(--tag-color);
  font-weight: 700;
  font-family: kufam;
}
.featured_story_fact_check_title {
  color: #ffffff;
  font-weight: 500;
  font-family: kufam;
  cursor: pointer;
}
.featured_story_fact_check_sub_title {
  color: var(----background-theme-color);
  font-weight: 400;
  cursor: pointer;
}
.featured_fact_check_thumbnail_overlay_title {
  height: 55%;
  display: flex;
  align-items: center;
}
.featured_fact_check_thumbnail_overlay_view_count {
  display: flex;
  align-items: center;
  gap: 10px;
}

.featured_fact_check_view_count {
  color: var(--view-icon-color-white);
}
.featured_fact_check_thumbnail_overlay_name_and_date {
  color: #ffffff;
}
.featured_fact_check_button {
  background-color: #140f2d !important;
  color: #ffffff !important;
  border-radius: 10px;
  border: 1px solid white !important;
  background: transparent !important;
}
.featured_fact_check_content_title_wrapper {
  display: flex;
  height: 40%;
  flex-direction: column;
  gap: 6%;
}
.featured_fact_check_content_sub_title_wrapper {
  display: flex;
  flex-direction: column;
  height: 60%;
  justify-content: space-evenly;
  
}
.featured_fact_check_title {
  color: #ffffff;
  
  padding: 2% 0 3% 0;
  font-weight: 700;
  font-family: kufam;
}
.featured_fact_check_title_container {
  background-color: #140f2d;
  width: 100%;
  display: flex;
  justify-content: center;
}
.featured_fact_check_back_ground_container {
  position: absolute;
  background-color: #140f2d;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 37%;
  z-index: 1;
}
.featured_story_fact_check_container {
  display: flex !important;
  justify-content: center !important;
  position: relative;
}
.featured_fact_check_mobile_view_title {
  
  font-family: kufam;
}
.featured_fact_check_mobile_view_sub_title {
  
  font-family: kufam;
}
.featured_fact_check_content_mobile_view {
  width: 90%;
  display: flex;
  flex-direction: column;
  padding: 5% 0 0% 0;
}
.featured_story_fact_check_container_mobile_view {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
}
.featured_fact_check_container_mobile_view {
  position: relative;
  z-index: 1;
  width: 90%;
}
.featured_fact_check_back_ground_container_mobile_view {
  position: absolute;
  background-color: #140f2d;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 25%;
  z-index: 1;
}

.fact_check_trending_stories_container {
  background-color: #140f2d;
  display: flex;
  flex-direction: column;
}
.fact_check_trending_stories_title_container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fact_check_trending_stories_title {
  
  font-weight: bold;
  font-family: "Kufam";
  color: white;
}
.fact_check_trending_stories_card_container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}
.fact_check_trending_stories_card_wrapper {
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fact_trending_details_container {
  background-color: rgba(0, 0, 0, 0.75);
  position: absolute;
  border-radius: 0px 0px 7px 7px;
  padding: 5px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 3px;
}

.browse_categories_container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  min-height: 500px;
}
.category_tag {
  cursor: pointer;
  padding: 5px 28px;
  border: 1px solid rgb(0, 101, 204);
  border-radius: 17px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 8px 8px;
  background-color: transparent;
  color: black;
}
.category_tags_wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.category_wise_list_container {
  width: 75%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 5px;
}
.category_wise_list_cards_wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  
}
.fact_category_wise_card_container {
  border-radius: 8px;
  z-index: 1;
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end !important;
  position: relative;
  cursor: pointer;
  overflow: hidden !important;
}
.fact_category_wise_card_container:hover .fact_category_wise_card_details_container{
  transform: translateY(100px);
  overflow: hidden;
  transition: 0.8s ease-in;

}
.fact_category_wise_card_image {
  width: 100% !important;
  height: 100% !important;
  border-radius: 8px 8px 8px 8px !important;
  object-fit: cover;
}
.fact_category_wise_card_details_container {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.75) !important;
  z-index: 2;
  position: absolute;
  border-radius: 0px 0px 7px 7px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  gap: 5px;
}
.fact_category_wise_card_title_container {
  width: 100%;
  height: 70%;
  padding: 3px;
  overflow: hidden;
}

.fact_category_wise_card_author_container {
  height: 24px;
  width: 100%;
  padding: 3px;
  display: flex;
  flex-direction: row;
}
.fact_category_wise_card_author_name_text {
  color: white;
  font-size: 10px;
}
.half_circle_container {
  position: sticky; 
  top: 80px;
  background: linear-gradient(
    166.4deg,
    #140f2d 9.74%,
    #f49d36 281.54%
  ) !important;
  border-radius: 15px 15px 0 0 !important; 
  height: 100% !important;
  max-height: 500px !important;
  min-height: 200px !important; 
  max-width: 100%; 
  min-width: 50%; 
  border: transparent !important;
  box-shadow: 0 0 10px rgba(0, 0, 255, 0.3) !important;
  clip-path: ellipse(100% 48% at 100% 50%); 
}

.fact_check_party_container {
  display: grid;
  grid-template-columns: 60% 35%;
  height: 100%;
  
  
  column-gap: 40px;
  
  width: 90%;
  justify-content: space-between;
}
.flex-1 {
  flex: 1 !important;
}
.fact_check_party_main_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.fact_check_main_card_box {
  width: 35%;
}
.fact_check_second_card_box {
  width: 58%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.fact_check_party_wise_module_title {
  font-family: "Kufam";
  font-weight: 700;
}
.fact_check_party_wise_tag_container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.fact_check_party_wise_tag {
  border: 1px solid rgb(0, 101, 204);
  padding: 5px 28px;
  border-radius: 17px;
  cursor: pointer;
}
.selected_fact_check_party_wise_tag {
  border: 1px solid rgb(0, 101, 204);
  padding: 5px 28px;
  border-radius: 17px;
  cursor: pointer;
  background-color: var(--become-member-button);
  color: white;
}

.fact_check_party_wise_second_column_container {
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  height: 100%;
}

.donation_main_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--background-theme-color);
  padding: 30px;
  border-radius: 17px;
  gap: 5px;
}

.donation_first_row_content {
  color: white;

  text-align: justify;
}
.donation_first_row_container > text {
  color: #fff;
  font-family: "Lato";
}
.donation_first_row_container_ta > text {
  color: #fff;
  font-family: "Lato";
}
.donation_second_row_container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.donation_second_row_container > h1 {
  color: var(--tag-color);
  font-family: "Kufam";
  font-weight: 600;
}

.donation_second_row_container_ta {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.donation_second_row_container_ta > h1 {
  color: var(--tag-color);
  font-family: "Kufam";
  font-weight: 600;
}
.amount_card_content {
  padding: 10px;
  background-color: #fff;
  color: black;
  border-radius: 10px;
  cursor: pointer;
}
.amount_card_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.donation_third_row_container {
  display: flex;
  flex-direction: column;
  
  align-content: center;
  gap: 10px;
}
.donation_third_row_container > h6,
.donation_third_row_container > h5 {
  color: #fff;
  font-family: "Kufam";
  font-weight: 600;
  display: flex;
}

.donation_third_row_container_ta {
  display: flex;
  flex-direction: column;
  
  align-content: center;
  gap: 10px;
}
.donation_third_row_container_ta > h6,
.donation_third_row_container_ta > h5 {
  color: #fff;
  font-family: "Kufam";
  font-weight: 600;
  display: flex;
}

.amount_input_container {
  width: 100%;
  justify-content: center;
  display: flex;
}
.donation_footer_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.donation_footer_container > text {
  color: gray;
  font-size: 13px;
}

.donation_footer_container_ta {
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 10px;
}
.donation_footer_container_ta > text {
  color: gray;
  font-size: 13px;
}

.amount_input {
  width: 100% !important;
  display: flex;
}

.amount_input > .ant-input-number-input-wrap > .ant-input-number-input {
  text-overflow: clip !important;
  width: 300px;
}
.amount_selected {
  background-color: var(--become-member-button);
  color: white;
  padding: 10px;
  border-radius: 15px;
  cursor: pointer;
}
.donate_button {
  background-color: var(--become-member-button);
  color: #fff !important;
  border: 1px solid var(--become-member-button);
}
.party_wise_fact_check_top_image_loading,
.party_wise_fact_check_title_loading {
  width: 100%;
}
.party_wise_fact_check_subtitle_loading > .ant-skeleton-paragraph {
  margin-block-start: 0px !important;
}

.party_wise_first_card_loading_container {
  display: flex;
  flex-direction: column !important;
  
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  width: 95% !important;
  height: 100% !important;
}

.fact_check_details_skeleton_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  justify-content: space-between;
  align-items: flex-start !important;
  width: 100% !important;
  padding: 10px;
}
.w-100 {
  width: 100% !important;
}
.fact_check_party_wise_second_column_loading {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.home_user_contribution_content_box {
  height: 100%;
}
.align_item_center {
  align-items: center !important;
}
.fact_check_party_wise_mobile_container {
  height: 100% !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.half_circle_wrapper {
  position: absolute;
  top: 13px;
  left: 50%;
  width: 100%;
  height: 95%;
  max-width: 100%;
  max-height: 95%;

  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

.fact_check_trending_stories_title {
  
  font-weight: bold;
  font-family: "Kufam";
  color: white;
}
.fact_check_trending_stories_card_container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}
.fact_check_trending_stories_card_wrapper {
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fact_check_trending_container {
  width: 95%;
  position: relative;
  margin-left: 5px;
  cursor: pointer;
  overflow: hidden;
}
.fact_check_trending_container:hover .fact_trending_details_container{
transform: translateY(80px);
overflow: hidden !important;
transition: 0.8s ease-in;
}

.fact_trending_image {
  width: 100% !important;
  object-fit: cover !important;
  border-radius: 10px !important;
  
}

.social_media_name {
  align-items: center;
  display: flex;
  justify-content: center;
}
.logo_container {
  height: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.white_font {
  color: #ffffff;
}
.logo_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 90%;
  height: 90%;
}
.social_media_logo {
  cursor: pointer;
}
.social_media_logo_container {
  display: flex;
  align-items: center;
  width: 20% !important;
  justify-content: flex-end;
}

.join_is_container {
  width: 100%;
  background: var(--gradient-color) !important;
  display: flex;
  flex-direction: row;
  padding: 15px 0px 15px 0px;
}

.join_us_first_column {
  width: 15%;
  height: 100%;
}
.join_us_second_column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  width: 70%;
}
.fact_check_party_wise_mobile_container
  > .fact_check_party_wise_mobile_container {
  gap: 10px;
}
.fact_check_mobile_title_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 4%;
}
.join_us_third_column {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.join_us_today_text {
  color: white;
  font-family: "Kufam";
}
.join_us_feature_text {
  font-weight: bold;
  color: white;
  font-family: "Kufam";
}
.join_us_button {
  background-color: var(--become-member-button);
  color: white;
  border-radius: 6px;
  border: none;
}
.join_us_button:hover {
  background-color: var(--become-member-button) !important;
  color: rgba(255, 255, 255, 0.766) !important;
}
.youturn_join_us_logo {
  background-color: transparent !important;
  opacity: 0.5;
  width: 75%;
}
.mobile_donation_container {
  width: 100%;
  height: 150px;
  background-color: pink;
}

.ant-skeleton.ant-skeleton-element .ant-skeleton-input {
  min-width: 0px;
}

.see_more_button {
  background-color: var(--become-member-button) !important;
  color: #ffffff !important;
  border-radius: 6px;
  border: none;
  width: 160px;
}

.see_more_button_divider {
  border-color: #000000 !important;
}

.category_wise_card_container_skeleton {
  width: 280px !important;
  height: 180px !important;
}

.fact_check_container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.featured_fact_check_title_overlay_skeleton {
  height: 20px !important;
  width: 100% !important;
}
.featured_story_content_skeleton {
  display: flex;
  flex-direction: column;
  padding: 2% 0 2% 1%;
  background-color: #ffffff;
}
.featured_story_image_skeleton {
  border-radius: 10px !important;
}
.featured_story_image_component {
  background-color: #ffffff;
  border-radius: 10px !important;
}
.donation_third_row_container > h6 {
  justify-content: center;
}
.join_us_feature_text_ta {
  font-weight: bold;
  color: white;
  font-family: "Kufam";
}
.donation_first_row_content_en {
  color: white;

  text-align: justify;
}
.home_user_contribution_image,
.recent_fact_check_thumbnail_container {
  overflow: hidden;
}
.home_user_contribution_card_container:hover
  > .home_user_contribution_image
  img {
  transform: scale(1.1);
  transition: transform 0.8s ease-in-out;
}
.fact_check_first_column_card_container:hover > .slot_image_box img {
  transform: scale(1.1);
  transition: transform 0.8s ease-in-out;
}
.fact_check_first_column_card_container:not(:hover) > .slot_image_box img {
  transition: transform 0.9s ease-in-out; 
}
.home_user_contribution_card_container:not(:hover)
  > .home_user_contribution_image
  img {
  transition: transform 0.9s ease-in-out; 
}
.recent_fact_check_card_container:hover
  > .recent_fact_check_thumbnail_container
  img {
  transform: scale(1.1);
  transition: transform 0.8s ease-in-out;
}
.recent_fact_check_card_container:not(:hover)
  > .recent_fact_check_thumbnail_container
  img {
  transition: transform 0.9s ease-in-out; 
}
.party_wise_updates_mobile_text {
  font-weight: 600;
}
.fact_category_wise_card_title_text {
  font-size: 11px;
  color: white;
  font-family: kufam;
  font-weight: 600;
}
.fact_check_browse_categories_title {
  font-family: "Kufam";
  font-weight: 700;
}
.half_circle {
  width: 90%;
  height: 100%;
}
.image_hover_effect {
  object-fit: cover;
}
.join_us_second_inner_container {
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.social_media_content_container {
  display: flex;
  padding: 10px;
  flex-direction: column;
}
.social_media_first_content {
  color: white;
  font-size: 10px;
}
.social_media_second_content {
  color: white;
  font-size: 14px;
  font-weight: 600;
}
.half_circle_container {
  height: 500px !important;
  max-height: 500px !important;
}
.social_media_logo {
  width: 40px;
}
.social_media_first_content {
  font-size: 15px;
}
.social_media_second_content {
  font-size: 18px;
}
.no_data_in_party_wise_mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
}
.party_wise_no_data {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 300px;
}
.claim_status {
  text-align: center;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_fact_check.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kDAAkD;EAClD,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;;AAE/B;AACA;EACE,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;;AAEX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;;AAE1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gDAAgD;EAChD,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT;;;;cAIY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,oDAAoD;EACpD,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;;;EAGZ,gBAAgB;;EAEhB,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;;EAEtB,qBAAqB;EACrB,SAAS;AACX;AACA;;EAEE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,qBAAqB;EACrB,SAAS;AACX;AACA;;EAEE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;;EAEE,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iCAAiC;;EAEjC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;EACpD,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;;EAEf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;AAEhC;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;AACA,2BAA2B;AAC3B,2BAA2B;AAC3B,wBAAwB;AACxB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;;AAEhC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,wDAAwD;EACxD,4CAA4C;AAC9C;AACA;EACE,wCAAwC;EACxC,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;;EAEZ,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;;;EAGE,sCAAsC;AACxC;AACA;;;EAGE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;;;EAGE,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".featured_fact_check_container {\n  width: 90%;\n  display: flex;\n  z-index: 2;\n  position: relative;\n  gap: 3%;\n}\n\n.featured_fact_check_image_component {\n  \n  height: 100%;\n  cursor: pointer;\n}\n.featured_fact_check_image {\n  width: 100% !important;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.featured_fact_check_thumbnail_overlay_content {\n  position: absolute !important;\n  bottom: 20px;\n  background-color: rgba(20, 15, 45, 0.9) !important;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 2%;\n}\n.featured_fact_check_image_component_title {\n  color: #ffffff;\n  font-weight: 550;\n}\n.featured_fact_check_content {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n}\n.featured_fact_check_continue_reading_wrapper {\n  display: flex;\n  align-items: center;\n}\n.featured_story_fact_check {\n  color: var(--tag-color);\n  font-weight: 700;\n  font-family: kufam;\n}\n.featured_story_fact_check_title {\n  color: #ffffff;\n  font-weight: 500;\n  font-family: kufam;\n  cursor: pointer;\n}\n.featured_story_fact_check_sub_title {\n  color: var(----background-theme-color);\n  font-weight: 400;\n  cursor: pointer;\n}\n.featured_fact_check_thumbnail_overlay_title {\n  height: 55%;\n  display: flex;\n  align-items: center;\n}\n.featured_fact_check_thumbnail_overlay_view_count {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.featured_fact_check_view_count {\n  color: var(--view-icon-color-white);\n}\n.featured_fact_check_thumbnail_overlay_name_and_date {\n  color: #ffffff;\n}\n.featured_fact_check_button {\n  background-color: #140f2d !important;\n  color: #ffffff !important;\n  border-radius: 10px;\n  border: 1px solid white !important;\n  background: transparent !important;\n}\n.featured_fact_check_content_title_wrapper {\n  display: flex;\n  height: 40%;\n  flex-direction: column;\n  gap: 6%;\n}\n.featured_fact_check_content_sub_title_wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 60%;\n  justify-content: space-evenly;\n  \n}\n.featured_fact_check_title {\n  color: #ffffff;\n  \n  padding: 2% 0 3% 0;\n  font-weight: 700;\n  font-family: kufam;\n}\n.featured_fact_check_title_container {\n  background-color: #140f2d;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.featured_fact_check_back_ground_container {\n  position: absolute;\n  background-color: #140f2d;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 37%;\n  z-index: 1;\n}\n.featured_story_fact_check_container {\n  display: flex !important;\n  justify-content: center !important;\n  position: relative;\n}\n.featured_fact_check_mobile_view_title {\n  \n  font-family: kufam;\n}\n.featured_fact_check_mobile_view_sub_title {\n  \n  font-family: kufam;\n}\n.featured_fact_check_content_mobile_view {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  padding: 5% 0 0% 0;\n}\n.featured_story_fact_check_container_mobile_view {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  position: relative;\n}\n.featured_fact_check_container_mobile_view {\n  position: relative;\n  z-index: 1;\n  width: 90%;\n}\n.featured_fact_check_back_ground_container_mobile_view {\n  position: absolute;\n  background-color: #140f2d;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 25%;\n  z-index: 1;\n}\n\n.fact_check_trending_stories_container {\n  background-color: #140f2d;\n  display: flex;\n  flex-direction: column;\n}\n.fact_check_trending_stories_title_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.fact_check_trending_stories_title {\n  \n  font-weight: bold;\n  font-family: \"Kufam\";\n  color: white;\n}\n.fact_check_trending_stories_card_container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.fact_check_trending_stories_card_wrapper {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.fact_trending_details_container {\n  background-color: rgba(0, 0, 0, 0.75);\n  position: absolute;\n  border-radius: 0px 0px 7px 7px;\n  padding: 5px;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  gap: 3px;\n}\n\n.browse_categories_container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  min-height: 500px;\n}\n.category_tag {\n  cursor: pointer;\n  padding: 5px 28px;\n  border: 1px solid rgb(0, 101, 204);\n  border-radius: 17px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 8px 8px;\n  background-color: transparent;\n  color: black;\n}\n.category_tags_wrapper {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.category_wise_list_container {\n  width: 75%;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 5px;\n}\n.category_wise_list_cards_wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 20px;\n  \n}\n.fact_category_wise_card_container {\n  border-radius: 8px;\n  z-index: 1;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: flex-end !important;\n  position: relative;\n  cursor: pointer;\n  overflow: hidden !important;\n}\n.fact_category_wise_card_container:hover .fact_category_wise_card_details_container{\n  transform: translateY(100px);\n  overflow: hidden;\n  transition: 0.8s ease-in;\n\n}\n.fact_category_wise_card_image {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 8px 8px 8px 8px !important;\n  object-fit: cover;\n}\n.fact_category_wise_card_details_container {\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.75) !important;\n  z-index: 2;\n  position: absolute;\n  border-radius: 0px 0px 7px 7px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px;\n  gap: 5px;\n}\n.fact_category_wise_card_title_container {\n  width: 100%;\n  height: 70%;\n  padding: 3px;\n  overflow: hidden;\n}\n\n.fact_category_wise_card_author_container {\n  height: 24px;\n  width: 100%;\n  padding: 3px;\n  display: flex;\n  flex-direction: row;\n}\n.fact_category_wise_card_author_name_text {\n  color: white;\n  font-size: 10px;\n}\n.half_circle_container {\n  position: sticky; \n  top: 80px;\n  background: linear-gradient(\n    166.4deg,\n    #140f2d 9.74%,\n    #f49d36 281.54%\n  ) !important;\n  border-radius: 15px 15px 0 0 !important; \n  height: 100% !important;\n  max-height: 500px !important;\n  min-height: 200px !important; \n  max-width: 100%; \n  min-width: 50%; \n  border: transparent !important;\n  box-shadow: 0 0 10px rgba(0, 0, 255, 0.3) !important;\n  clip-path: ellipse(100% 48% at 100% 50%); \n}\n\n.fact_check_party_container {\n  display: grid;\n  grid-template-columns: 60% 35%;\n  height: 100%;\n  \n  \n  column-gap: 40px;\n  \n  width: 90%;\n  justify-content: space-between;\n}\n.flex-1 {\n  flex: 1 !important;\n}\n.fact_check_party_main_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.fact_check_main_card_box {\n  width: 35%;\n}\n.fact_check_second_card_box {\n  width: 58%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.fact_check_party_wise_module_title {\n  font-family: \"Kufam\";\n  font-weight: 700;\n}\n.fact_check_party_wise_tag_container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.fact_check_party_wise_tag {\n  border: 1px solid rgb(0, 101, 204);\n  padding: 5px 28px;\n  border-radius: 17px;\n  cursor: pointer;\n}\n.selected_fact_check_party_wise_tag {\n  border: 1px solid rgb(0, 101, 204);\n  padding: 5px 28px;\n  border-radius: 17px;\n  cursor: pointer;\n  background-color: var(--become-member-button);\n  color: white;\n}\n\n.fact_check_party_wise_second_column_container {\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  align-items: center;\n  height: 100%;\n}\n\n.donation_main_container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: var(--background-theme-color);\n  padding: 30px;\n  border-radius: 17px;\n  gap: 5px;\n}\n\n.donation_first_row_content {\n  color: white;\n\n  text-align: justify;\n}\n.donation_first_row_container > text {\n  color: #fff;\n  font-family: \"Lato\";\n}\n.donation_first_row_container_ta > text {\n  color: #fff;\n  font-family: \"Lato\";\n}\n.donation_second_row_container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}\n.donation_second_row_container > h1 {\n  color: var(--tag-color);\n  font-family: \"Kufam\";\n  font-weight: 600;\n}\n\n.donation_second_row_container_ta {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}\n.donation_second_row_container_ta > h1 {\n  color: var(--tag-color);\n  font-family: \"Kufam\";\n  font-weight: 600;\n}\n.amount_card_content {\n  padding: 10px;\n  background-color: #fff;\n  color: black;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.amount_card_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n.donation_third_row_container {\n  display: flex;\n  flex-direction: column;\n  \n  align-content: center;\n  gap: 10px;\n}\n.donation_third_row_container > h6,\n.donation_third_row_container > h5 {\n  color: #fff;\n  font-family: \"Kufam\";\n  font-weight: 600;\n  display: flex;\n}\n\n.donation_third_row_container_ta {\n  display: flex;\n  flex-direction: column;\n  \n  align-content: center;\n  gap: 10px;\n}\n.donation_third_row_container_ta > h6,\n.donation_third_row_container_ta > h5 {\n  color: #fff;\n  font-family: \"Kufam\";\n  font-weight: 600;\n  display: flex;\n}\n\n.amount_input_container {\n  width: 100%;\n  justify-content: center;\n  display: flex;\n}\n.donation_footer_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.donation_footer_container > text {\n  color: gray;\n  font-size: 13px;\n}\n\n.donation_footer_container_ta {\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  gap: 10px;\n}\n.donation_footer_container_ta > text {\n  color: gray;\n  font-size: 13px;\n}\n\n.amount_input {\n  width: 100% !important;\n  display: flex;\n}\n\n.amount_input > .ant-input-number-input-wrap > .ant-input-number-input {\n  text-overflow: clip !important;\n  width: 300px;\n}\n.amount_selected {\n  background-color: var(--become-member-button);\n  color: white;\n  padding: 10px;\n  border-radius: 15px;\n  cursor: pointer;\n}\n.donate_button {\n  background-color: var(--become-member-button);\n  color: #fff !important;\n  border: 1px solid var(--become-member-button);\n}\n.party_wise_fact_check_top_image_loading,\n.party_wise_fact_check_title_loading {\n  width: 100%;\n}\n.party_wise_fact_check_subtitle_loading > .ant-skeleton-paragraph {\n  margin-block-start: 0px !important;\n}\n\n.party_wise_first_card_loading_container {\n  display: flex;\n  flex-direction: column !important;\n  \n  cursor: pointer;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  width: 95% !important;\n  height: 100% !important;\n}\n\n.fact_check_details_skeleton_wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  justify-content: space-between;\n  align-items: flex-start !important;\n  width: 100% !important;\n  padding: 10px;\n}\n.w-100 {\n  width: 100% !important;\n}\n.fact_check_party_wise_second_column_loading {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.home_user_contribution_content_box {\n  height: 100%;\n}\n.align_item_center {\n  align-items: center !important;\n}\n.fact_check_party_wise_mobile_container {\n  height: 100% !important;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.half_circle_wrapper {\n  position: absolute;\n  top: 13px;\n  left: 50%;\n  width: 100%;\n  height: 95%;\n  max-width: 100%;\n  max-height: 95%;\n\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  \n}\n\n.fact_check_trending_stories_title {\n  \n  font-weight: bold;\n  font-family: \"Kufam\";\n  color: white;\n}\n.fact_check_trending_stories_card_container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.fact_check_trending_stories_card_wrapper {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.fact_check_trending_container {\n  width: 95%;\n  position: relative;\n  margin-left: 5px;\n  cursor: pointer;\n  overflow: hidden;\n}\n.fact_check_trending_container:hover .fact_trending_details_container{\ntransform: translateY(80px);\noverflow: hidden !important;\ntransition: 0.8s ease-in;\n}\n\n.fact_trending_image {\n  width: 100% !important;\n  object-fit: cover !important;\n  border-radius: 10px !important;\n  \n}\n\n.social_media_name {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.logo_container {\n  height: 35%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n}\n.white_font {\n  color: #ffffff;\n}\n.logo_wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 90%;\n  height: 90%;\n}\n.social_media_logo {\n  cursor: pointer;\n}\n.social_media_logo_container {\n  display: flex;\n  align-items: center;\n  width: 20% !important;\n  justify-content: flex-end;\n}\n\n.join_is_container {\n  width: 100%;\n  background: var(--gradient-color) !important;\n  display: flex;\n  flex-direction: row;\n  padding: 15px 0px 15px 0px;\n}\n\n.join_us_first_column {\n  width: 15%;\n  height: 100%;\n}\n.join_us_second_column {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n  width: 70%;\n}\n.fact_check_party_wise_mobile_container\n  > .fact_check_party_wise_mobile_container {\n  gap: 10px;\n}\n.fact_check_mobile_title_container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 4%;\n}\n.join_us_third_column {\n  width: 15%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.join_us_today_text {\n  color: white;\n  font-family: \"Kufam\";\n}\n.join_us_feature_text {\n  font-weight: bold;\n  color: white;\n  font-family: \"Kufam\";\n}\n.join_us_button {\n  background-color: var(--become-member-button);\n  color: white;\n  border-radius: 6px;\n  border: none;\n}\n.join_us_button:hover {\n  background-color: var(--become-member-button) !important;\n  color: rgba(255, 255, 255, 0.766) !important;\n}\n.youturn_join_us_logo {\n  background-color: transparent !important;\n  opacity: 0.5;\n  width: 75%;\n}\n.mobile_donation_container {\n  width: 100%;\n  height: 150px;\n  background-color: pink;\n}\n\n.ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n  min-width: 0px;\n}\n\n.see_more_button {\n  background-color: var(--become-member-button) !important;\n  color: #ffffff !important;\n  border-radius: 6px;\n  border: none;\n  width: 160px;\n}\n\n.see_more_button_divider {\n  border-color: #000000 !important;\n}\n\n.category_wise_card_container_skeleton {\n  width: 280px !important;\n  height: 180px !important;\n}\n\n.fact_check_container {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n.featured_fact_check_title_overlay_skeleton {\n  height: 20px !important;\n  width: 100% !important;\n}\n.featured_story_content_skeleton {\n  display: flex;\n  flex-direction: column;\n  padding: 2% 0 2% 1%;\n  background-color: #ffffff;\n}\n.featured_story_image_skeleton {\n  border-radius: 10px !important;\n}\n.featured_story_image_component {\n  background-color: #ffffff;\n  border-radius: 10px !important;\n}\n.donation_third_row_container > h6 {\n  justify-content: center;\n}\n.join_us_feature_text_ta {\n  font-weight: bold;\n  color: white;\n  font-family: \"Kufam\";\n}\n.donation_first_row_content_en {\n  color: white;\n\n  text-align: justify;\n}\n.home_user_contribution_image,\n.recent_fact_check_thumbnail_container {\n  overflow: hidden;\n}\n.home_user_contribution_card_container:hover\n  > .home_user_contribution_image\n  img {\n  transform: scale(1.1);\n  transition: transform 0.8s ease-in-out;\n}\n.fact_check_first_column_card_container:hover > .slot_image_box img {\n  transform: scale(1.1);\n  transition: transform 0.8s ease-in-out;\n}\n.fact_check_first_column_card_container:not(:hover) > .slot_image_box img {\n  transition: transform 0.9s ease-in-out; \n}\n.home_user_contribution_card_container:not(:hover)\n  > .home_user_contribution_image\n  img {\n  transition: transform 0.9s ease-in-out; \n}\n.recent_fact_check_card_container:hover\n  > .recent_fact_check_thumbnail_container\n  img {\n  transform: scale(1.1);\n  transition: transform 0.8s ease-in-out;\n}\n.recent_fact_check_card_container:not(:hover)\n  > .recent_fact_check_thumbnail_container\n  img {\n  transition: transform 0.9s ease-in-out; \n}\n.party_wise_updates_mobile_text {\n  font-weight: 600;\n}\n.fact_category_wise_card_title_text {\n  font-size: 11px;\n  color: white;\n  font-family: kufam;\n  font-weight: 600;\n}\n.fact_check_browse_categories_title {\n  font-family: \"Kufam\";\n  font-weight: 700;\n}\n.half_circle {\n  width: 90%;\n  height: 100%;\n}\n.image_hover_effect {\n  object-fit: cover;\n}\n.join_us_second_inner_container {\n  height: 90%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.social_media_content_container {\n  display: flex;\n  padding: 10px;\n  flex-direction: column;\n}\n.social_media_first_content {\n  color: white;\n  font-size: 10px;\n}\n.social_media_second_content {\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n}\n.half_circle_container {\n  height: 500px !important;\n  max-height: 500px !important;\n}\n.social_media_logo {\n  width: 40px;\n}\n.social_media_first_content {\n  font-size: 15px;\n}\n.social_media_second_content {\n  font-size: 18px;\n}\n.no_data_in_party_wise_mobile {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 150px;\n}\n.party_wise_no_data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 300px;\n}\n.claim_status {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
